<template>
	<div>
		<div class="title">保障信息</div>
		<Form :model="form" :label-width="125" ref="form" class="mt15">
			<FormItem label="保障期限：" class="w600" required>
				1个月
			<!-- <Select 
				v-model="form.insurancePeriod" 
				placeholder="请选择保障期限：" 
				style="width:100%"
				disabled
				@on-change="dateChange('insurancePeriod')">
				<Option value="1">1个月</Option>
			</Select> -->
		</FormItem>
			<FormItem label="保险起期：" class="w600" prop="beginDate"
				:rules="{ required: true, message: '请选择保障起期', type: 'date', trigger: 'change' }">
				<DatePicker v-model="form.beginDate" type="date" placeholder="请选择保障起期" style="width: 100%" @on-change="dateChange('beginDate')" :options="dateOptions">
				</DatePicker>
			</FormItem>
			<FormItem label="保险止期：" class="w600" required>
				{{ form.endDate }}
			</FormItem>
			<FormItem label="保障方案：" class="w600" prop="insurancePlan"
				:rules="{required:true,message:'请选择保障方案',trigger:'change'}">
				<Select 
					v-model="form.insurancePlan" 
					placeholder="请选择保障方案" 
					style="width:100%"
					clearable
					@on-change="schemeChange">
					<Option :value="item.code" v-for="(item, index) in schemeList" :key="index">{{ item.name }}</Option>
				</Select>
			</FormItem>
		</Form>
		<div class="download-btn">
			<div>
				<UploadFile style="display:inline-block" url="/pc/casual/insurance/user/import" :show-upload-list="false" :data="uploadParams" btn-text="上传参保人员" :disabled="!form.insurancePlan||!form.beginDate||!form.endDate" @on-success="uploadSuccess" />
				<span class="downloadFile ml15">
					<a @click="download">下载模板</a>
				</span>
			</div>
			<div>
				<Button type="error" @click="clearPersonList" v-show="list.length > 0">清空已上传数据</Button>
			</div>
		</div>
		<Table class="mt15" :columns="columns" :data="listPageData" highlight-row disabled-hover>
			<template slot-scope="{ row, index }" slot="manage">
				<a @click="del(index)">删除</a>
			</template>
		</Table>
		<div v-if="list.length > 0 && list.length < 3" class="warning-message">
			<Icon type="ios-warning" color="#ed4014" size="16" style="margin-right: 5px;" />
			<span style="color: #ed4014;">每次投保人数不得少于3人</span>
		</div>
		<!-- 分页组件 -->
		<div class="pagination-container" v-if="list.length > pageSize">
			<Page 
				:total="list.length" 
				:current="currentPage" 
				:page-size="pageSize"
				@on-change="handlePageChange"
				show-total
				@on-page-size-change="handlePageSizeChange"
			/>
		</div>
	</div>
</template>
<script>
import UploadFile from '../common/UploadFile'
export default {
	components: { UploadFile },
	props: {
		info: Object,
	},
	data() {
		return {
			id: this.$route.params.id,
			columns: [
				{ title: '姓名', key: 'name', minWidth: 120 },
				{ title: '身份证号', key: 'idNo', minWidth: 160},
				{ title: '性别', key: 'genderName', minWidth: 80},
				{ title: '年龄', key: 'age', minWidth: 80},
				{ title: '操作', slot: 'manage', width: 70 },
			],
			list: [],
			form: {},
			dateOptions: {},
			schemeList: [], // 保障方案列表
			isReset: this.$route.query.reset || '',
			// 分页相关
			currentPage: 1,
			pageSize: 10
		}
	},
	computed: {
		// 外层表格的分页数据
		listPageData() {
			const start = (this.currentPage - 1) * this.pageSize;
			const end = start + this.pageSize;
			return this.list.slice(start, end);
		},
		uploadParams() {
			return {
				insurancePlan: this.form.insurancePlan, // 添加保障方案
				beginDate: this.formatDate(this.form.beginDate),
				endDate: this.formatDate(this.form.endDate)
			}
		}
	},
	watch: {
		info(v) {
			this.setData();
			if (v.billNo) {
				if(this.form.insurancePlan){
					this.form.insurancePlan = String(this.form.insurancePlan);
				} else {
					this.form.insurancePlan = '';
				}
				this.setStartTimeOption();
				this.getSchemeList(); // 获取保障方案列表
			}
		},
		// 监听投保人数变化，通知父组件
		'list.length'(newVal) {
			this.$emit('person-count-change', newVal < 3);
		}
	},
	created() {
		this.setData();
		if (!this.isReset) {
			this.setStartTimeOption();
		}
		this.getSchemeList(); // 初始化时获取保障方案列表
	},
	methods: {
		// 获取保障方案列表
		getSchemeList() {
			this.$axios.post('/casual/plan').then(res => {
				this.schemeList = res.map(item => ({
					...item,
					code: String(item.code)
				}));
			});
		},
		// 保障方案变化
		schemeChange(value) {
			this.$set(this.form, 'insurancePlan', value||'');
			// 使用$nextTick确保DOM更新后再执行后续操作
			this.$nextTick(() => {
				this.getPremium();
			});
		},
		// 清空人员信息
		clearPersonList() {
			this.$Modal.confirm({
				title: '确定清空人员信息？',
				okText: '取消',
				cancelText: '确认',
				onOk: () => {},
				onCancel: () => {
					this.list = []
					this.currentPage = 1
					this.getPremium()
					// 通知父组件人数变化
					this.$emit('person-count-change', true);
				}
			});
		},
		// 分页相关方法
		handlePageChange(page) {
			this.currentPage = page;
		},
		handlePageSizeChange(pageSize) {
			this.pageSize = pageSize;
			this.currentPage = 1;
		},
		async setStartTimeOption() {
			this.dateOptions = {
				disabledDate(date) {
					return date && date.valueOf() < Date.now();
				}
			}
		},
		setData() {
			this.form = this.jsonCopy(this.info);
			if (this.info.users) {
				this.list = this.info.users;
				// 通知父组件人数变化
				this.$emit('person-count-change', this.list.length < 3);
			}
		},
		// 校验
		async val() {
			let flag = await this.$refs.form.validate();
			return new Promise((resolve, reject) => {
				if (flag && this.list.length > 0) {
					resolve({
						beginDate: this.formatDate(this.form.beginDate),
						endDate: this.form.endDate,
						insurancePlan: this.form.insurancePlan,
						premium: this.totalAmount,
						users: this.list
					})
				} else {
					this.toast('保障信息或上传人员错误', 'error');
					resolve(false)
				}
			})
		},
		// 日期变化
		async dateChange(type) {
			if (this.form.beginDate) {
				try {
					const endDate = await this.getEffectiveDateEnd(this.formatDate(this.form.beginDate));
					if (endDate) {
						this.$set(this.form, 'endDate', endDate);
						// 确保 endDate 设置后再计算保费
						this.getPremium();
					} else {
						console.error('获取保障止期失败：返回值为空');
					}
				} catch (error) {
					console.error('获取保障止期失败：', error);
				}
			} else {
				// 如果没有开始日期，清空结束日期
				this.$set(this.form, 'endDate', '');
			}
		},
		// 获取保障止期
		getEffectiveDateEnd(beginDate) {
			return this.$axios.post('/casual/calculateEndDate.json', {
				beginDate: beginDate
			}).then(res => {
				if (res && res.endDate) {
					return res.endDate;
				} else {
					throw new Error('接口返回的 endDate 为空');
				}
			}).catch(error => {
				console.error('获取保障止期接口调用失败：', error);
				throw error;
			});
		},
		// 上传成功后，仅保存数据，不再弹出校验结果
		uploadSuccess(res) {
			this.list = res.data.users;
			this.getPremium();
			this.currentPage = 1;
			// 通知父组件人数变化
			this.$emit('person-count-change', this.list.length < 3);
		},
		// 删除
		del(index) {
			this.$Modal.confirm({
				title: '确定删除？',
				okText: '取消',
				cancelText: '确认',
				onOk: () => {},
				onCancel: () => {
					this.list.splice(index, 1);
					this.getPremium();
					// 通知父组件人数变化
					this.$emit('person-count-change', this.list.length < 3);
				}
			});
		},
		// 下载模板
		download() {
			window.open('/static/excel/参保人员导入模版.xlsx', '_blank')
		},
		/*获取保费*/
		async getPremium() {
			if (this.list.length == 0) {
				this.$emit('set-amount', 0)
				this.totalAmount = 0
				return
			}
			let obj = {
				users: this.list,
				beginDate: this.formatDate(this.form.beginDate),
				endDate: this.formatDate(this.form.endDate),
				insurancePlan: this.form.insurancePlan
			}
			// 检查必要的参数
			if (!obj.beginDate) {
				console.warn('开始日期为空，无法计算保费');
				return;
			}
			if (!obj.endDate) {
				console.warn('结束日期为空，无法计算保费');
				return;
			}
			if (!obj.insurancePlan) {
				console.warn('保障方案为空，无法计算保费');
				return;
			}
			
			try {
				let res = await this.$axios.post('/casual/insurance/premium/calculate.json', obj)
				this.$emit('set-amount', res.premium)
				this.totalAmount = res.premium;
			} catch (error) {
				console.error('计算保费失败：', error);
			}
		}
	}
}
</script>
<style scoped lang="less">
	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}
	.download-btn{
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
	.warning-message {
		margin-top: 15px;
		padding: 10px;
		background-color: #fff7e6;
		border: 1px solid #ffe58f;
		border-radius: 4px;
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/recognize.vue